/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".change-level-modal .modal-dialog{height:90%}  .change-level-modal .modal-dialog .modal-content{border-radius:16px;overflow:hidden;height:100%;width:100%}  .modal-lg{max-width:880px}[_nghost-%COMP%]{height:100%;width:100%}"];
export { styles as styles };
//# sourceMappingURL=change-level-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/level-selection/change-level-modal/change-level-modal.component.scss.shim.ngstyle.js
// module id = 1758
// module chunks = 27 28 29